<template>

  <div class="flex flex-col lg:flex-row lg:items-center lg:gap-8">    
    <div class="hidden lg:flex lg:w-6/12 justify-center items-center">
      <img src="@/assets/desktop_agrupadas.png" class="w-full object-contain" />
    </div>

    <section id="formulario" class="py-12 clash-font">

      <div class="w-full">
        <div class="flex flex-col items-center">
          <img class="pb-3 object-contain w-6/12 sm:w-5/12 lg:block lg:w-3/12" src="@/assets/logo.png" />
        </div>
        <div class="flex flex-col items-center pb-2 text-white text-center">
          <span class="text-4xl md:text-4xl font-semibold">Argentina Alimenta</span>
          <span class="text-xl mt-2">{{$t('label.fecha')}}</span>
          <span class="text-xl">{{ $t('label.lugar') }}</span>
        </div>

        <img src="@/assets/mobile_agrupadas_1.png" class="lg:hidden mx-auto px-4 py-2 mb-3"/>

        <div class="flex flex-col items-center w-full">
          <div class="flex items-center gap-4">
            <button @click="changeLanguage('es')" class="hover:opacity-70 transition">
              <img src="@/assets/ar.svg" class="h-6 rounded-full"/>
            </button>
            <button @click="changeLanguage('en')"  class="hover:opacity-70 transition">
              <img src="@/assets/us.svg" class="h-6 rounded-full"/>
            </button>
          </div>      
        </div>
      </div>

      <div class="container mx-auto px-4 py-6 pt-10 max-w-6xl items-center text-center">
        <router-link to="/" 
          class="px-4 py-3 w-full clash-font rounded-lg border-2 bg-[#262E63] border-[#262E63] text-white hover:bg-[#212750] hover:text-[#29A5DE] hover:border-[#29A5DE] text-xl">
          <i v-show="!isSubmitting" class="pi pi-user mr-2"></i>{{ $t('label.soy.visitante') }}
        </router-link>
      </div>


      <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4  text-white" @invalid-submit="onInvalidSubmit">

        <div class="container mx-auto px-4 py-6 max-w-6xl ">

          <h1 class="text-3xl text-white w-full text-center pb-2 clash-font">{{ $t('label.registro.prensa') }}</h1>
          <h1 class="text-2xl text-white w-full text-center pb-2 clash-font">{{ $t('label.titulo.form') }}</h1>

          <!-- Formulario -->
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-4/12">
              <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
                <label class="block mb-1">{{ $t('label.dni') }}</label>
                <InputText v-bind="field" type="text" @blur="validarDni" :placeholder="$t('label.dni')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="dni" /></span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-4/12">
              <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
                <label class="block mb-1">{{ $t('label.nombre') }}</label>
                <InputText v-bind="field" type="text" :placeholder="$t('label.nombre')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="nombre" /></span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-4/12">
              <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
                <label class="block mb-1">{{ $t('label.apellido') }}</label>
                <InputText v-bind="field" type="text" :placeholder="$t('label.apellido')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="apellido" /></span>
              </Field>
            </div>
          </div>

          
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">{{ $t('label.nombre.medio') }}</label>
              <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
                <InputText v-bind="field" type="text" :placeholder="$t('label.nombre.medio')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="empresa" /></span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-6/12" :class="{ 'md:w-6/12': formData.cargo?.id === 'Otro' }">
              <label class="block mb-1">{{ $t('label.cargo.funcion') }}</label>
              <Field name="cargo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.cargo">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" :placeholder="$t('global.seleccione.opcion')" class="input-base" :options="cargos" optionLabel="descripcion">
                  <template #option="{ option }">
                    {{ $t(option.descripcion) }}
                  </template>
                  <template #value="{ value }">
                    {{ value ? $t(value.descripcion) : $t('global.seleccione.opcion') }}
                  </template>
                </Select>
                <span class="text-xl text-red-200"><ErrorMessage name="cargo" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-12/12" v-if="formData.cargo?.id === 'Otro'">
              <label class="block mb-1">{{  $t('label.otro.cargo') }}</label>
              <Field name="otroCargo" v-slot="{ field, errors }" v-model="formData.otroCargo">
                <InputText v-bind="field" type="text" :placeholder="$t('label.otro.cargo')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="otroCargo" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full md:w-3/12 px-2">
              <label class="block mb-1">{{ $t("label.pais.telefono")}}</label>
              <Select v-model="selectedCountryPhone" filter :options="paises" optionLabel="descripcion" class="input-base input-success" />
            </div>
            <div class="w-full md:w-2/12 px-2">
              <label class="block mb-1">{{ $t("label.pais.telefono.codigo") }}</label>
              <InputText type="text" v-if="selectedCountryPhone !== null" v-model="selectedCountryPhone.id" class="input-base input-success" readonly />
            </div>
            <div class="w-full md:w-3/12 px-2">
              <label class="block mb-1">{{ $t("label.codigo.area") }}</label>
              <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
                <InputText v-bind="field" type="text" :placeholder="$t('label.codigo.area')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
              </Field>
            </div>
            <div class="w-full md:w-4/12 px-2">
              <label class="block mb-1">{{ $t("label.telefono") }}</label>
              <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
                <InputText v-bind="field" type="text" :placeholder="$t('label.telefono')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-12/12">
              <label class="block mb-1">{{  $t('label.mail') }}</label>
              <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
                <InputText v-bind="field" type="text" :placeholder="$t('label.mail')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="mail" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">{{ $t('label.pais.residencia') }}</label>
              <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.pais">
                <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" :placeholder="$t('global.seleccione.opcion')" class="input-base" :options="paises" optionLabel="descripcion" />
                <span class="text-sm text-red-500"><ErrorMessage name="pais" /></span>
              </Field>
            </div>

            <div class="w-full px-2 md:w-6/12" v-if="formData.pais?.id == '+54'">
              <label class="block mb-1">{{  $t('label.provincia') }}</label>
              <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :placeholder="$t('global.seleccione.opcion')" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="provincia" /></span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-6/12" v-if="formData.pais?.id != '+54'">
              <label class="block mb-1">{{  $t('label.provincia.estado') }}</label>
              <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
                <InputText v-bind="field" type="text" :placeholder="$t('label.provincia.estado')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="provinciaEstado" /></span>
              </Field>
            </div>          
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">Twitter (x.com)</label>
              <Field name="twitter" v-slot="{ field, errors }" v-model="formData.twitter">
                <InputText v-bind="field" type="text" placeholder="Twitter (x.com)" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="twitter" /></span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">Instagram</label>
              <Field name="instagram" v-slot="{ field, errors }" v-model="formData.instagram">
                <InputText v-bind="field" type="text" placeholder="Instagram" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="instagram" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 py-1">
            <div class="w-full px-2">
              <label class="block mb-1">{{  $t('label.otra.red') }}</label>
              <Field name="otraRed" v-slot="{ field, errors }" v-model="formData.otraRed">
                <InputText v-bind="field" type="text" :placeholder="$t('label.otra.red')" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-xl text-red-200"><ErrorMessage name="otraRed" /></span>
              </Field>              
            </div>
            <div class="w-full px-2">
              <label class="block mb-1 text-gray-300">{{ $t('label.mensaje.red')}} </label>
              
            </div>
          </div>


          <div class="flex flex-wrap py-2">
            <button type="submit"
              class="mt-8 px-4 py-3 w-full clash-font rounded-lg border-2 bg-[#262E63] border-[#262E63] text-white hover:bg-[#212750] hover:text-[#29A5DE] hover:border-[#29A5DE] text-3xl"
              :disabled="isSubmitting">
              <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
              <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>{{ $t('boton.registrarme') }}
            </button>
          </div>

        </div>

      </Form>

        <img src="@/assets/mobile_agrupadas_2.png" class="lg:hidden mx-auto px-4 py-2 mb-3"/>

    </section>
  </div>


  <FullScreenLoader :visible="isSubmitting"/>

</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import suiteService, { Acreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity, TipoAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';

import { VERIFICADO, ORIGEN_ACREDITADO, SAVE, A_VERIFICAR } from "qreventos-suite/constantes";

import idiomaService from '@/services/idioma.services';

import jsonCargosPrensa from '@/data/cargosPrensa.json';
import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';

interface Cargo extends StringIdLabelEntity { }
interface Pais  extends StringIdLabelEntity {}
interface Provincia extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select, 
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      isSubmitting: false,
      cargos: jsonCargosPrensa as Cargo[],
      paises: jsonCountries as Pais[],
      provincias: jsonProvincias as Provincia[],
      selectedCountryPhone: { "id": "+54", "descripcion": "Argentina" } as Pais,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        empresa: '',
        cargo: undefined as unknown as Cargo,
        codigoArea: '',
        telefonoCelular: '',
        mail: '',
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        pais: {"id": "+54", "descripcion": "Argentina"} as Pais,
        otroCargo: '',        
        twitter: '',
        instagram: '',
        otraRed: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required(this.$t('error.campo.obligatorio')).min(8, this.$t('error.min.8')),
        nombre: yup.string().required(this.$t('error.campo.obligatorio')).min(3, this.$t('error.min.3')),
        apellido: yup.string().required(this.$t('error.campo.obligatorio')).min(3, this.$t('error.min.3')),
        empresa: yup.string().required(this.$t('error.campo.obligatorio')).min(3, this.$t('error.min.3')),
        mail: yup.string().required(this.$t('error.campo.obligatorio')).email(this.$t('error.mail.invalido')),
        codigoArea: yup.string().required(this.$t('error.campo.obligatorio')),
        telefonoCelular: yup.string().required(this.$t('error.campo.obligatorio')),

//        twitter: yup.string().required(this.$t('error.campo.obligatorio')),
//        instagram: yup.string().required(this.$t('error.campo.obligatorio')),
        //        otraRed: yup.string().required(this.$t('error.campo.obligatorio')),

twitter: yup.string().test(
  'al-menos-una-red',
  this.$t('error.campo.obligatorio.red'),
  function (value) {
    const { instagram, otraRed } = this.parent;
    return !!value || !!instagram || !!otraRed;
  }
),
instagram: yup.string().test(
  'al-menos-una-red',
  this.$t('error.campo.obligatorio.red'),
  function (value) {
    const { twitter, otraRed } = this.parent;
    return !!value || !!twitter || !!otraRed;
  }
),
otraRed: yup.string().test(
  'al-menos-una-red',
  this.$t('error.campo.obligatorio.red'),
  function (value) {
    const { twitter, instagram } = this.parent;
    return !!value || !!twitter || !!instagram;
  }
        ),
        
        provincia: yup.mixed().test('validacion-provincia-argentina', this.$t('global.seleccione.opcion'), function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', this.$t('error.campo.obligatorio'), function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),

        cargo: yup.mixed().required(this.$t('global.seleccione.opcion')),

        otroCargo: yup.mixed().test('validacion-otros', this.$t('error.campo.obligatorio'), function (value) {
          if (this.parent.cargo?.id == 'Otro' && !value) {
            return false;
          }
          return true;
        }),

      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;

      console.log(values);
      console.log(values?.errors);
      
      Swal.fire({ title: this.$t('global.atencion'), html: this.$t('error.hay.errores') + " (" + errores + ")", icon: "error"});
    },
    async validarDni() {
      try {
        if (this.formData.dni) {
          this.isSubmitting = true;
          let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.dni) as Acreditado;
          if (acreditadoExistente) {
            Swal.fire({ title: this.$t('global.atencion'), html: this.$t('error.dni.existe'), icon: "warning" });
            return;
          }
        }
      } catch (error) {
        Swal.fire({ title: this.$t('global.atencion'), text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },       
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    },
    async onSubmit() {
      this.isSubmitting = true;
      try {

        const acreditadoExiste: Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.dni);
        if (acreditadoExiste && acreditadoExiste.estadoAcreditado.id === VERIFICADO) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.ya.registrado'), icon: "warning" }).then(() => {
            this.cancelarAcreditacion();
          });
          return;
        }

        let acreditado: Acreditado = {} as Acreditado;
        acreditado.tipoAcreditado = { "id": 2660 } as TipoAcreditado;
        acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;

        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.cargo?.id;
        acreditado.telefono = this.selectedCountryPhone.id + this.formData.codigoArea + this.formData.telefonoCelular;
        acreditado.mail = this.formData.mail;
        acreditado.cantidad = 1;

        acreditado.dato3 = this.formData.pais.descripcion;
        if (this.formData.pais?.id == "+54") {
          acreditado.dato4 = this.formData.provincia?.descripcion;
        } else {
          acreditado.dato4 = this.formData.provinciaEstado;
        }

        acreditado.dato7 = this.formData.otroCargo;
        acreditado.dato9 = this.formData.twitter;
        acreditado.dato10 = this.formData.instagram;
        acreditado.dato11 = this.formData.otraRed;

        acreditado.notificar = true;
        acreditado.modificado = SAVE;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('label.registro.prensa.ok'), html: this.$t('mensaje.registro.prensa.ok'), icon: "success" }).then(() => {
            this.cancelarAcreditacion();
          });
        }

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
  }
});
</script>